export const MEINE_REGION_MIN_KM = 1;
export const MEINE_REGION_MAX_KM = 100;

export const DEFAULT_MEINE_REGION_RADIUS_KM = 20;

// Keep the persisted value 'MY_RADIUS_STORE' so existing users don't lose their saved radius
export const REGIONALFUNK_RADIUS_STORE_KEY = 'MY_RADIUS_STORE';
